import { studioExpertNoviceSessionUrl } from 'shared-utils';

export type Page = { url?: string | null; title?: string | null; description?: string | null };
export type Pages = { before?: Page | null; after?: Page | null };
export type PageMode = 'default' | 'custom' | 'off';
export const placements = ['before', 'after'] as const;
export const pageLabels = { before: 'Before the call', after: 'After the call' };
/** Saved verbatim — the backend swaps the placeholders in when it serves the page. */
export const sessionPageUrlTemplate = studioExpertNoviceSessionUrl({
  bookingId: '{{booking_id}}',
  sessionCode: '{{session_code}}',
});
export const sessionPageUrlHelp =
  'Use {{booking_id}} and {{session_code}} anywhere in the URL — each is replaced with this study and session when a participant opens the page.';
export const sessionPageInsertLabel = 'Insert assistant/user script URL';
export const pageMode = (page?: Page | null): PageMode => {
  if (page == null) return 'default';
  return page.url?.trim() ? 'custom' : 'off';
};
